import React, { useContext, useEffect, useState } from 'react';
import { ToastContext } from '../providers/ToastContext';
// Import Polaris web component types
import '../../types/polaris-web-components.d';

export const Toast = () => {
  const { toast, hide } = useContext(ToastContext);
  const [mounted, setMounted] = useState(false);
  const [entered, setEntered] = useState(false);

  // Auto-dismiss toast after 5 seconds
  useEffect(() => {
    if (toast.visible) {
      const timer = setTimeout(() => {
        hide();
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [toast.visible, hide]);

  // Drive enter/exit transitions and keep the pill mounted until it finishes leaving
  useEffect(() => {
    if (toast.visible) {
      setMounted(true);
      const raf = requestAnimationFrame(() => setEntered(true));
      return () => cancelAnimationFrame(raf);
    }
    setEntered(false);
    const timer = setTimeout(() => setMounted(false), 200);
    return () => clearTimeout(timer);
  }, [toast.visible]);

  if (!mounted) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '24px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        maxWidth: '400px',
        width: '100%',
        padding: '0 16px',
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          background: toast.isError ? '#d72c0d' : '#202223',
          color: 'white',
          padding: '12px 16px',
          borderRadius: '8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '12px',
          boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
          opacity: entered ? 1 : 0,
          transform: entered ? 'translateY(0)' : 'translateY(12px)',
          transition: 'opacity 0.2s ease-out, transform 0.2s ease-out',
        }}
      >
        <span style={{ fontSize: '14px' }}>{toast.message}</span>
        <s-button variant="tertiary" icon="x" accessibilityLabel="Dismiss" aria-label="Dismiss" onClick={hide} />
      </div>
    </div>
  );
};

export default Toast;
